// Whole-word, Unicode-aware profanity matcher.
// Substring matches cause false positives (Scunthorpe problem). We anchor the
// match against non-letter/non-number boundaries using Unicode property classes
// so words composed of any-language letters still count as boundaries.

const PROFANE_WORDS = ["damn", "hell"] as const

function escapeRegex(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

const PROFANITY_PATTERN = new RegExp(
  `(?<![\\p{L}\\p{N}])(?:${PROFANE_WORDS.map(escapeRegex).join("|")})(?![\\p{L}\\p{N}])`,
  "iu"
)

export function containsProfanity(value: string) {
  return PROFANITY_PATTERN.test(value)
}

export const PROFANE_WORDS_FOR_TEST: readonly string[] = PROFANE_WORDS
